import type { getMatchCardStyles } from './MatchCard.styles';
import type { Theme } from '../../../src/theme/getTheme';

/**
 * Derives the 8 outcome-dependent style values shared by MatchCardFinished and MatchCardLive.
 * Both cards render the same accent bar, boost glow, badge, and label variants — only the
 * hit/result booleans differ.
 */
export function resolveMatchCardOutcomeStyles(
  isExact: boolean,
  isResult: boolean,
  isBoosted: boolean,
  styles: ReturnType<typeof getMatchCardStyles>,
  theme: Theme,
) {
  return {
    cardBorder: isExact ? styles.finishedCardHit : isResult ? styles.finishedCardResult : styles.finishedCardMiss,
    accentBar: isExact ? styles.accentBarHit : isResult ? styles.accentBarResult : styles.accentBarMiss,
    outcomeLabelStyle: isExact ? styles.outcomeLabelHit : isResult ? styles.outcomeLabelResult : styles.outcomeLabelMiss,
    outcomeLabel: isExact ? 'Exact' : isResult ? 'Result' : ('Miss' as string),
    boostGlow: isBoosted
      ? isExact ? styles.finishedCardBoostedHit : isResult ? styles.finishedCardBoostedResult : styles.finishedCardBoostedMiss
      : undefined,
    boostBadgeStyle: isBoosted
      ? isExact ? styles.finishedBoostMiniBadgeHit : isResult ? styles.finishedBoostMiniBadgeResult : styles.finishedBoostMiniBadgeMiss
      : undefined,
    boostBadgeTextStyle: isBoosted
      ? isExact ? styles.finishedBoostMiniBadgeTextHit : isResult ? styles.finishedBoostMiniBadgeTextResult : styles.finishedBoostMiniBadgeTextMiss
      : undefined,
    boostZapColor: isBoosted
      ? isExact ? theme.success : isResult ? theme.info : theme.error
      : theme.accent,
  };
}
